module.exports = __webpack_public_path__ + "img/capa_livro_padrao.ba519449.jpeg";